import { DesignProp, GeneralProp } from "../PropCategories";

export const fontSize = {
  name: "Font Size",
  nameI18n: "builder_ui.prop_type.styles.font_size",
  category: [DesignProp, GeneralProp],
  type: "slider",
  defaultValue: "16px",
  sliderProps: {
    units: ["rem", "px"],
    step: 1,
    defaultUnit: "rem",
    min: 0,
    max: 500,
  },
} as const;
